import createHistory from 'history/createBrowserHistory'
import * as React from 'react';
import { routerMiddleware } from 'react-router-redux'
import { applyMiddleware, compose, createStore, Store } from 'redux';

// import { createLogger } from 'redux-logger';
import { loadUser } from 'redux-oidc';


import * as ReactDOM from 'react-dom';
import { actionTypes } from '../constants/actionTypes';
import { conf } from '../constants/config/configVars';
import { uploadProfile } from '../utils/api';
import userManager from '../utils/userManager';
import { TransitionModal } from './../components/TransitionModal/index';
import { refreshActiveNode } from './actions';
import reducer from './reducer';



export const history = createHistory({
  basename: conf.uri_basename,
  getUserConfirmation(message: string, callback: any) {
    const modal = document.querySelector('#transModal')
    const transitionCallback = (bool: boolean) => {
      callback(bool)
      ReactDOM.unmountComponentAtNode(modal!)
    }
    ReactDOM.render(<TransitionModal message={message} transitionAllowed={transitionCallback} />, modal )

  }
})

const initialState = {}

// DEVTOOLS
const composeEnhancers = typeof window === 'object' && window['__REDUX_DEVTOOLS_EXTENSION__'] ? window['__REDUX_DEVTOOLS_EXTENSION__']({ // tslint:disable-line
  // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
}) : compose;

// const composeEnhancers = typeof window === 'object' && window['devToolsExtension'] ? window['devToolsExtension']({ // tslint:disable-line
//   // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
// }) : compose;


const createStoreWithMiddleware = composeEnhancers(applyMiddleware(routerMiddleware(history))(createStore))

const store: Store = createStoreWithMiddleware(reducer, initialState);

store.subscribe(() => {
  // PROFILE CHANGES
  const type = store.getState().lastaction.type
  const updatableProfileActions = [
    actionTypes.SWITCH_EDITOR_THEME,
    actionTypes.SWITCH_EDITOR_VIEW,
    actionTypes.SWITCH_GENERATOR_VIEW,
    actionTypes.SWITCH_APP_LANGUAGE,
    actionTypes.SWITCH_TOOLTIPS,
    actionTypes.TOGGLE_LOGGING,
    actionTypes.TOGGLE_DELETE_CONFIRMATION,
    actionTypes.TOGLE_SHOW_LOG_INFO
  ]
  const toUpdateProfile = updatableProfileActions.find((el) => {
    return el === type
  })
  // If Profile should be updated. Do it.
  if (toUpdateProfile) {
    uploadProfile()
  }

  // ACTIVE NODE CHANGES
  // Check if generatorList or Active Node got changes

    // const currentState: IState = store.getState();
    if (
      type === actionTypes.LOAD_GENERATORS_SUCCESS
      || type === actionTypes.LOAD_REMAINING_GENERATOR_DETAIL_SUCCESS
      || type === actionTypes.UPDATE_ACTIVE_NODE
      || type === actionTypes.DELETE_GENERATOR_START) {
      store.dispatch(refreshActiveNode());
    }



})


loadUser(store, userManager)

export default store;



// WEBPACK FOOTER //
// ./src/store/store.tsx